export default "__VITE_ASSET__CNhueYJn__"